import React from 'react'
import { roundWithLocale } from 'utils/math'
import Section from '../Section'
import Separator from '../Separator'
import Header, { Title } from '../Header'
import { AttributeList, AttributeColumns } from '../Attribute'
import ColorAttribute from '../ColorAttribute'
import { ColorProps } from '../Attribute/components/Color'
import copy from './copy'
import { ColorFormat, ColorVariable } from 'modules/shares/types'
import FullCopyAttribute from '../FullCopyAttribute'

interface ArtboardSizeProps {
  artboardWidth: number
  artboardHeight: number
  color?: ColorProps
  onColorFormatChange: (f: ColorFormat) => void
  colorFormat: ColorFormat
  colorVariables: { [key: string]: ColorVariable }
}

const ArtboardSize: React.FC<ArtboardSizeProps> = ({
  artboardWidth,
  artboardHeight,
  color,
  colorVariables,
  onColorFormatChange,
  colorFormat,
}) => {
  const sectionCopyValue = copy({
    artboardWidth,
    artboardHeight,
    color,
    colorFormat,
  })

  return (
    <>
      <Separator />
      <Section data-testid="inspector-sidebar-artboard-size">
        <Header copyValue={sectionCopyValue}>
          <Title>Artboard</Title>
        </Header>
        <AttributeColumns>
          <FullCopyAttribute
            display="block"
            label="Width"
            value={`${roundWithLocale(artboardWidth, 2)}`}
          />
          <FullCopyAttribute
            display="block"
            label="Height"
            value={`${roundWithLocale(artboardHeight, 2)}`}
          />
        </AttributeColumns>
        {color && (
          <>
            <Separator />
            <AttributeList>
              <ColorAttribute
                label="Background"
                red={color.red}
                green={color.green}
                blue={color.blue}
                alpha={color.alpha}
                colorVariableID={color.colorVariableID}
                colorVariables={colorVariables}
                onColorFormatChange={onColorFormatChange}
                colorFormat={colorFormat}
              />
            </AttributeList>
          </>
        )}
      </Section>
    </>
  )
}

export default ArtboardSize
